import ContentManagement from '../ContentManagement';

export default function ContentManagementListView() {
  return <ContentManagement />;
}
